import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

interface DelayedFadeProps {
  delay: number;
}

export const DelayedFade = styled(Box)<DelayedFadeProps>(({ delay }) => ({
  animation: 'fadeIn 1000ms ease-in',
  animationDelay: `${delay}ms`,
  animationFillMode: 'backwards',
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}));
